import { render, staticRenderFns } from "./LibraryAndChannelBrowserMainContent.vue?vue&type=template&id=270a93b4"
import script from "./LibraryAndChannelBrowserMainContent.vue?vue&type=script&lang=js"
export * from "./LibraryAndChannelBrowserMainContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports